var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClickTapSingleHandGestureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5928 30.1018L10.974 28.6634C10.1647 27.935 9.54028 27.0331 9.14715 26.0156L6.82193 19.5984C6.62537 19.055 6.87975 18.4537 7.40006 18.2109C7.6764 18.0838 7.9539 18.0259 8.24296 18.0259C8.9714 18.0259 9.67671 18.4318 10.0352 19.1244L12.1627 23.4025C12.8795 22.8706 13.2958 22.0266 13.2958 21.1478V7.51562C13.2969 6.55594 14.0716 5.78125 15.0313 5.78125C15.991 5.78125 16.7657 6.55594 16.7657 7.51562V16.7656C16.7657 15.8059 17.5404 15.0312 18.5001 15.0312C19.4597 15.0312 20.2344 15.8059 20.2344 16.7656V17.3438C20.2344 16.3841 21.0091 15.6094 21.9688 15.6094C22.9285 15.6094 23.7032 16.3841 23.7032 17.3438V18.5C23.7032 17.5403 24.4779 16.7656 25.4376 16.7656C26.3972 16.7656 27.1719 17.5403 27.1719 18.5V27.8541C27.1719 28.6345 26.9384 29.3953 26.5094 30.0405",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7613 4.24575L10.9438 3.42828",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 2.89062V1.73438",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.301 4.24575L19.1185 3.42828",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 7.51562H20.8125",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.51562H10.4062",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 35.2656V31.7969H27.1719V35.2656",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5928 30.1018L10.974 28.6634C10.1647 27.935 9.54028 27.0331 9.14715 26.0156L6.82193 19.5984C6.62537 19.055 6.87975 18.4537 7.40006 18.2109C7.6764 18.0838 7.9539 18.0259 8.24296 18.0259C8.9714 18.0259 9.67671 18.4318 10.0352 19.1244L12.1627 23.4025C12.8795 22.8706 13.2958 22.0266 13.2958 21.1478V7.51562C13.2969 6.55594 14.0716 5.78125 15.0313 5.78125C15.991 5.78125 16.7657 6.55594 16.7657 7.51562V16.7656C16.7657 15.8059 17.5404 15.0312 18.5001 15.0312C19.4597 15.0312 20.2344 15.8059 20.2344 16.7656V17.3438C20.2344 16.3841 21.0091 15.6094 21.9688 15.6094C22.9285 15.6094 23.7032 16.3841 23.7032 17.3438V18.5C23.7032 17.5403 24.4779 16.7656 25.4376 16.7656C26.3972 16.7656 27.1719 17.5403 27.1719 18.5V27.8541C27.1719 28.6345 26.9384 29.3953 26.5094 30.0405",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7613 4.24575L10.9438 3.42828",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 2.89062V1.73438",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.301 4.24575L19.1185 3.42828",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 7.51562H20.8125",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.51562H10.4062",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 35.2656V31.7969H27.1719V35.2656",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickTapSingleHandGestureIcon);
export default __webpack_public_path__ + "static/media/click_tap_single_hand_gesture_icon.d0b07d32b6b9638722717709ed54d378.svg";
export { ForwardRef as ReactComponent };